import { format } from 'date-fns';
import { useIntl } from 'react-intl';

import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';

import {
  ExpiringIcon,
  ExpiringPoints,
  ExpiringPointsContainer,
  IconContainer,
  PointsToExpireText,
} from './loyalty-rewards.styled';

export const LoyaltyRewardsExpiringPoints: React.FC = () => {
  const { loyaltyUser, loading: loyaltyLoading } = useLoyaltyUser();

  const expirationDate = loyaltyUser?.expirationBuckets?.[0]?.expirationDate || null;
  const currentPoints = loyaltyUser?.expirationBuckets?.[0]?.pointsToExpire || 0;

  const dateFormat = 'MMMM do';
  const date = expirationDate && new Date(expirationDate);
  const formattedDate = date && format(date.setDate(date.getDate()), dateFormat);
  const { formatMessage } = useIntl();

  if (!loyaltyLoading && (currentPoints <= 0 || expirationDate === null)) {
    return null;
  }

  return (
    !loyaltyLoading && (
      <ExpiringPointsContainer>
        <ExpiringPoints>
          <IconContainer>
            <ExpiringIcon />
          </IconContainer>
          {formatMessage({ id: 'youHave' })}
          <PointsToExpireText>
            {currentPoints} {formatMessage({ id: 'points' })}
          </PointsToExpireText>
          {formatMessage(
            {
              id: 'expiringWithDate',
            },
            {
              expiringDate: formattedDate,
            }
          )}
        </ExpiringPoints>
      </ExpiringPointsContainer>
    )
  );
};
